import {Component} from '@angular/core';

@Component({
    selector: 'scitis-required-field-indicator-explanation',
    templateUrl: './required-field-indicator-explanation.component.html',
    styleUrls: ['./required-field-indicator-explanation.component.scss'],
    standalone: false
})
export class RequiredFieldIndicatorExplanationComponent {
}
